'use client';

import React from 'react';
import VideoSlider from '../education/VideoSlider';

const videos = [
  {
    id: 'b1Jysp5qfd4',
    title: 'How to Transfer ETH from Coinbase.com to Coinbase Wallet',
    url: 'https://www.youtube.com/shorts/b1Jysp5qfd4',
  },
  {
    id: 'YXRP2sR9KVk',
    title: 'How to avoid airdrop scams in Coinbase Wallet',
    url: 'https://www.youtube.com/shorts/YXRP2sR9KVk',
  },
  {
    id: 'ULHp_z_kgKs',
    title: 'How to identify legit trending projects on Coinbase Wallet',
    url: 'https://www.youtube.com/shorts/ULHp_z_kgKs',
  },
  {
    id: 'CtBk2lNinig',
    title: 'How to Hide Assets in Coinbase Wallet',
    url: 'https://www.youtube.com/shorts/CtBk2lNinig',
  },
  {
    id: 'DcZfeSCjGDI',
    title: 'How to Buy Boomer on Coinbase Wallet',
    url: 'https://www.youtube.com/shorts/DcZfeSCjGDI',
  },
  {
    id: 'Ht-wTCXSjvs',
    title: 'How to create a Coinbase Wallet Id (cb.id)',
    url: 'https://www.youtube.com/shorts/Ht-wTCXSjvs',
  },
  {
    id: 'LMeIeB7-pfg',
    title: 'What is a Crypto Network?',
    url: 'https://www.youtube.com/shorts/LMeIeB7-pfg',
  },
  {
    id: '--cm3x7DiOc',
    title: 'What is Burned Liquidity?',
    url: 'https://www.youtube.com/shorts/--cm3x7DiOc',
  },
  {
    id: '3zP1lup28sg',
    title: 'What Happens When I Add to a Liquidity Pool?',
    url: 'https://www.youtube.com/shorts/3zP1lup28sg',
  },
  {
    id: 'C0318vhxfIs',
    title: 'Bitcoin Halving for Boomers',
    url: 'https://www.youtube.com/shorts/C0318vhxfIs',
  },
  {
    id: 'AoMbFzfgjxc',
    title: 'Liquidity Pools for Boomers',
    url: 'https://www.youtube.com/shorts/AoMbFzfgjxc',
  },
];

// Fisher-Yates shuffle algorithm
const shuffleArray = <T,>(array: T[]): T[] => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

const EducationSection = () => {
  const shuffledVideos = React.useMemo(() => shuffleArray(videos), []);

  return (
    <section className="py-20">
      <div className="container mx-auto px-4">
        <div className='mb-12 text-center'>
          <h2 className='mb-4 bg-gradient-to-r from-blue-500 to-purple-500 bg-clip-text font-bold text-4xl text-transparent md:text-5xl'>
            Crypto Safety Education
          </h2>
          <p className='mx-auto max-w-2xl text-gray-300 text-xl'>
            Learn essential crypto safety tips and wallet management through our
            curated video collection.
          </p>
        </div>

        <div className="py-8">
          <VideoSlider videos={shuffledVideos} />
        </div>

        <div className='mt-12 text-center'>
          <a
            href="https://www.youtube.com/channel/UCCoNp8uHwoNhmfKrOz0K31g"
            target="_blank"
            rel="noopener noreferrer"
            className='inline-block rounded-full bg-blue-500 px-8 py-3 font-bold text-white transition-colors hover:bg-blue-600'
          >
            View All Videos
          </a>
        </div>
      </div>
    </section>
  );
};

export default EducationSection;
